import debounce from 'lodash-es/debounce'
import { useEffect, useRef, useState } from 'react'

/** Hooks used to detect window resizes and to
 * enforce component refreshes when the resizes happen. */
export const useResizeWindow = () => {
  const sizeKey = () => `${window.innerHeight}-${window.innerWidth}`
  const [key, setKey] = useState(sizeKey())
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  const debouncedWindowResizeHandler = useRef(
    debounce(() => setKey(sizeKey()), 300),
  )

  useEffect(function subscribeToWindowResizes() {
    window.addEventListener('resize', debouncedWindowResizeHandler.current)

    const eventHandler = debouncedWindowResizeHandler.current

    return () => window.removeEventListener('resize', eventHandler)
  }, [])

  return key
}
